import type { IGrade, IPagination, ISearchable } from 'shared/types'
import { client } from '../clients'

const createRecord = (record: IGrade) => client.post('/grades', record)

const getList = (page: number) => client.get<IPagination<IGrade>>('/grades', {
  params: { page }
})

const getRecord = (recordId: string) => client.get(`/grades/${recordId}`)

const updateRecord = (record: IGrade) =>
  client.put(`/grades/${record.id}`, record)

const removeRecord = (recordId: string) => client.delete(`/grades/${recordId}`)

const search = (params: ISearchable) => client.get<IGrade[]>('/grades/all', {
  params
})

export const grades = {
  record: {
    create: createRecord,
    get: getRecord,
    update: updateRecord,
    remove: removeRecord
  },
  getList,
  search
}
